module.exports = __webpack_public_path__ + "img/zf_tab_1.363a4db1.png";